import React from "react";
import styles from "./PerfectWith.module.css";
import { Link } from "react-router-dom";
import NewPolaroid from "./../NewPolaroid";
import {handleImgError} from "../../Shared/ImageError";

function PerfectWith({ product }) {
  return (
    <div className={styles.PerfectWithSection}>
      {product.Categories && product.Categories.length > 0 ? (
        <div className={styles.PerfectFor}>
          <div className={styles.Title}>Perfect For...</div>
          <div className={styles.PerfectForProducts}>
            {product.Categories.map((category, i) => (
              <Link to={`/Products/${category.FriendlyName}`} key={i}>
                <div className={styles.CategoryItem}>
                  {/* <div className={styles.CategoryItemCircle}></div> */}
                  <div>                    
                    <img
                      className={styles.CategoryItemImage}
                      src={category.CategoryImage}
                      alt={category.CategoryName}
                      onError={handleImgError}
                    />
                  </div>
                  <div className={styles.CategoryItemLabel}>
                    {category.CategoryName}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      ) : null}
      {product.PerfectWith && product.PerfectWith.length > 0 ? (
        <div className={styles.PerfectWith}>
          <div className={styles.Title}>Perfect With...</div>
          <div className={styles.PerfectWithProducts}>            
            {product.PerfectWith.map((item, i) => (
              <NewPolaroid
                key={i}
                Id={item.Id}
                Name={item.Name}
                Price={item.Price}
                Images={item.Images}
                FriendlyName={item.FriendlyName}
              />
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default PerfectWith;
